"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// Modules
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_ga_1 = require("react-ga");
var ScrollToTop_jsx_1 = require("./components/scrollToTop/ScrollToTop.jsx");
var ReadAloudControls_jsx_1 = require("./components/readAloudControls/ReadAloudControls.jsx");
var MainRouter_jsx_1 = require("./routers/MainRouter.jsx");
var useCookieConsent_1 = require("./hooks/useCookieConsent");
var _a = process.env.REACT_APP_MARKET_VALUES, GOOGLE_ANALYTICS_ID = _a.GOOGLE_ANALYTICS_ID, IS_EPISOD_ENABLED = _a.IS_EPISOD_ENABLED;
var debugStatus = process.env.NODE_ENV !== 'production';
var App = function () {
    var cookieCategory2 = (0, useCookieConsent_1.default)().cookieCategory2;
    (0, react_1.useEffect)(function () {
        if (cookieCategory2 && IS_EPISOD_ENABLED !== 'true') {
            react_ga_1.default.initialize(GOOGLE_ANALYTICS_ID, {
                debug: debugStatus,
                gaOptions: { siteSpeedSampleRate: 100, storage: 'none', name: 'customer_service' },
            });
            react_ga_1.default.ga('create', GOOGLE_ANALYTICS_ID, 'auto');
        }
    }, [cookieCategory2]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "app", children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.BrowserRouter, { children: [(0, jsx_runtime_1.jsx)(ScrollToTop_jsx_1.default, {}), (0, jsx_runtime_1.jsx)(ReadAloudControls_jsx_1.default, {}), (0, jsx_runtime_1.jsx)(MainRouter_jsx_1.default, {})] }) }));
};
exports.default = (0, react_router_dom_1.withRouter)(App);
